import { render, staticRenderFns } from "./IstihkakList.vue?vue&type=template&id=5fe92c56"
import script from "./IstihkakList.vue?vue&type=script&lang=ts"
export * from "./IstihkakList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports